// src/Pages/PartnerAccount/EditSocialLinks.jsx
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ipAddress } from '../../../config';
import './EditSocialLinks.css';

const PLATFORM_OPTIONS = [
  'GitHub',
  'LinkedIn',
  'Twitter',
  'Instagram',
  'Website',
  'Facebook',
  'YouTube',
  'TikTok',
  'Snapchat',
  'WhatsApp',
  'Telegram',
  'Discord',
  'Menu',
];

const EditSocialLinks = () => {
  const partnerId = localStorage.getItem('partnerId');
  const [links, setLinks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    axios
      .post(`${ipAddress}/api/PartnerAccountRoutes/get_partner_with_social_links`, { partnerId })
      .then(res => setLinks(res.data.socialLinks || []))
      .catch(err => {
        console.error(err);
        setError('Failed to load links');
      })
      .finally(() => setLoading(false));
  }, [partnerId]);

  const handleChange = (idx, field, value) => {
    const copy = [...links];
    copy[idx][field] = value;
    setLinks(copy);
  };

  const handleAdd = () => {
    // Determine which platforms are already used
    const usedNames = links.map(l => l.name);
    // Find the first platform that isn't in usedNames
    const available = PLATFORM_OPTIONS.find(opt => !usedNames.includes(opt));

    if (available) {
      setLinks([...links, { name: available, link: '' }]);
    }
    // If 'available' is undefined, that means all PLATFORM_OPTIONS are already used.
    // In that case, the Add button will already be disabled (see below), so user can't click.
  };

  const handleDelete = idx => {
    setLinks(links.filter((_, i) => i !== idx));
  };

  const handleSave = () => {
    setSaving(true);
    axios
      .post(`${ipAddress}/api/PartnerAccountRoutes/add_social_links_to_partner`, {
        partnerId,
        socialLinks: links.map(({ name, link }) => ({ name, link })),
      })
      .then(() => alert('Saved!'))
      .catch(err => {
        console.error(err);
        setError('Save failed');
      })
      .finally(() => setSaving(false));
  };

  if (loading) return <p>Loading…</p>;
  if (error) return <p style={{ color: 'red' }}>{error}</p>;

  // Disable Add button if we've used every platform already
  const allUsed = links.length >= PLATFORM_OPTIONS.length;

  return (
    <div className="edit-socials-container">
      <h2>Edit Social Links</h2>
      <text>(use full link with https eg. https://facebook.com/yourpage)</text>
      {links.map((item, i) => (
        <div className="link-row" key={i}>
          <select
            value={item.name}
            onChange={e => handleChange(i, 'name', e.target.value)}
          >
            {PLATFORM_OPTIONS.map(opt => {
              // Disable any option that is already used in another row
              const isSelectedElsewhere = links.some((l, j) => j !== i && l.name === opt);
              return (
                <option key={opt} value={opt} disabled={isSelectedElsewhere}>
                  {opt}
                </option>
              );
            })}
          </select>
          <input
            type="url"
            placeholder="https://..."
            value={item.link}
            onChange={e => handleChange(i, 'link', e.target.value)}
          />
          <button
            type="button"
            className="delete-link-btn"
            onClick={() => handleDelete(i)}
          >
            ×
          </button>
        </div>
      ))}

      <button
        onClick={handleAdd}
        className="add-link-btn"
        disabled={allUsed}
        title={allUsed ? 'All platforms have been added' : ''}
      >
        + Add another
      </button>

      <button
        onClick={handleSave}
        disabled={saving}
        className="save-links-btn"
      >
        {saving ? 'Saving…' : 'Save All'}
      </button>
    </div>
  );
};

export default EditSocialLinks;
